import { corsBypass, REACT_APP_BASE_URL_METIS } from "../constants/enviroments";
import axios from "axios";
import { interceptorHelper } from "./interceptor";
import { handleAxiosError } from "./Axios";

const baseMetisUrl = `${REACT_APP_BASE_URL_METIS}`;

let AppointmentsAxios = axios.create({
  baseURL: `${
    process.env.NODE_ENV === "development" ? corsBypass : ""
  }${baseMetisUrl}`,
});

AppointmentsAxios.interceptors.request.use(
  interceptorHelper.config,
  interceptorHelper.error
);

AppointmentsAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    return handleAxiosError(error);
  }
);

export async function GetAppointmentsSchedule() {
  return AppointmentsAxios.get(`/availability`);
}

export async function UpdateAppointmentsSchedule(data) {
  return AppointmentsAxios.patch(`/availability/bulk-update`, data);
}

export async function AddAppointmentsSchedule(data) {
  return AppointmentsAxios.post(`/availability`, data);
}

export async function GetAppointments() {
  return AppointmentsAxios.get(`/appointments`);
}

export async function ProcessAppointment(data, id) {
  return AppointmentsAxios.patch(`/appointments/${id}/respond`, data);
}

export async function AddAppointment(data) {
  return await AppointmentsAxios.post(`/appointments`, data);
}

export async function GetMentors(params) {
  return await AppointmentsAxios.get(`/mentors`, {
    params,
  });
}
export async function FilterMentors(data) {
  return await AppointmentsAxios.post(`/mentors/filter`, data);
}

export async function UpdateUserEducation(data) {
  return AppointmentsAxios.post(`/user/education`, data);
}

export async function UpdateSingleEducation(data, id) {
  return AppointmentsAxios.patch(`/user/education/${id}`, data);
}

export async function DeleteEducation(id) {
  return AppointmentsAxios.delete(`/user/education/${id}`);
}

export async function UpdateUserCareer(data) {
  return AppointmentsAxios.post(`/user/careers`, data);
}

export async function UpdateSingleCareer(data, id) {
  return AppointmentsAxios.patch(`/user/careers/${id}`, data);
}

export async function DeleteCareer(id) {
  return AppointmentsAxios.patch(`/user/careers/${id}`);
}

export async function updateUserInterests(data) {
  return AppointmentsAxios.post(`/users/mentorship/interests`, data);
}

export async function updateUserSetings(data) {
  return AppointmentsAxios.patch(`/settings`, data);
}

export async function createUserSetings(data) {
  return AppointmentsAxios.post(`/settings`, data);
}

export async function getUserSetings() {
  return AppointmentsAxios.get(`/settings`);
}

export async function resendVerification() {
  return AppointmentsAxios.get(`/users/verification/email`);
}
